import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasReportedesaldosfacturacionComponent ($q, $moment, FinanzasReportedesaldosfacturacion, $state) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.obtenerInformacion = obtenerInformacion
  $ctrl.exportar = exportar

  function $onInit () {
    $ctrl.idsEmpresas = $ctrl.idsEmpresas || []

    $ctrl.data = undefined

    $ctrl.$promise = $q.all({
        empresas: FinanzasReportedesaldosfacturacion.getEmpresas(),
        facturado: $ctrl.idsEmpresas.length ? FinanzasReportedesaldosfacturacion.get($ctrl.idsEmpresas) : null,
      })
      .then(($resolve) => {
        $ctrl.empresas = $resolve.empresas.data
        $ctrl.data = $resolve.facturado
      })
  }

  function obtenerInformacion () {
    $state.go($state.current, {
      idsEmpresas: $ctrl.idsEmpresas,
    })
  }

  function exportar () {
    FinanzasReportedesaldosfacturacion.exportarXLS($ctrl.data, 'EmpresasFacturado')
  }
}

module.component('finanzasReportedesaldosfacturacion', {
  controller: FinanzasReportedesaldosfacturacionComponent,
  template,
  bindings: {
    idsEmpresas: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/_/reportedesaldosfacturacion/components/component.js